import Loading from '../../../Common/Loading';
import { useSectorizationChartsDataContext } from './hooks/useSectorizationChartsDataContext';
import { SectorizationByNeighborhoodMonthly } from './SectorizationByNeighborhoodMonthly';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useSectorizationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <SectorizationByNeighborhoodMonthly />
        </>
    );
};
